module.exports = __webpack_public_path__ + "media/images/shapes/blurs/blur-2-ec0b0440d9b1b9ba517a4cec110d4082.svg";